(function () {
  'use strict';
  var SELECTOR = '[data-ds-pdp-360]';
  function normalizeIndex(index, length) {
    return ((index % length) + length) % length;
  }
  function initViewer(root) {
    if (!root || root.dataset.ds360Ready === 'true') return;
    var frame = root.querySelector('[data-ds-360-frame]');
    var stage = root.querySelector('[data-ds-360-stage]');
    var prev = root.querySelector('[data-ds-360-prev]');
    var next = root.querySelector('[data-ds-360-next]');
    var json = root.querySelector('[data-ds-360-frames]');
    var range = root.querySelector('[data-ds-360-range]');
    if (!frame || !stage || !json) return;
    var frames;
    try {
      frames = JSON.parse(json.textContent || '[]');
    } catch (error) {
      frames = [];
    }
    frames = frames.filter(Boolean);
    if (frames.length < 2) return;
    root.dataset.ds360Ready = 'true';
    /*
     * ============================================================
     * DRIP 360 — CLEAN / STABLE
     * ============================================================
     *
     * Objetivo:
     * - uma única imagem visível;
     * - sem crossfade;
     * - sem double buffer;
     * - sem animação artificial;
     * - troca somente para frame já carregado/decodificado;
     * - arraste acumulado para evitar "vai e volta" / tremida.
     */
    frame.draggable = false;
    frame.style.transition = 'none';
    frame.style.animation = 'none';
    frame.style.transform = 'translateZ(0)';
    frame.style.backfaceVisibility = 'hidden';
    frame.style.webkitBackfaceVisibility = 'hidden';
    var connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    var saveData = !!(connection && connection.saveData);
    var effectiveType =
      connection && connection.effectiveType
        ? String(connection.effectiveType)
        : '';
    var slowConnection =
      /(^|-)2g$|slow-2g/.test(effectiveType);
    /*
     * ============================================================
     * CACHE
     * ============================================================
     */
    var cache = new Array(frames.length);
    var ready = new Array(frames.length);
    var loading = new Array(frames.length);
    var current = 0;
    var wanted = 0;
    var paintToken = 0;
    /*
     * Sensibilidade equivalente ao Best Sellers que ficou liso.
     * Menor número = responde com menos deslocamento do dedo.
     */
    var FRAME_STEP = 6;
    function updateRange(index) {
      if (!range) return;
      range.value = String(index);
      var max = Math.max(
        1,
        frames.length - 1
      );
      var progress =
        (index / max) * 100;
      range.style.setProperty(
        '--ds-360-progress',
        progress + '%'
      );
    }
    updateRange(0);
    cache[0] = frame;
    if (frame.complete && frame.naturalWidth > 0) {
      ready[0] = true;
    } else {
      frame.addEventListener(
        'load',
        function () {
          ready[0] = true;
        },
        { once: true }
      );
    }
    function preload(index, urgent) {
      index = normalizeIndex(index, frames.length);
      if (ready[index]) {
        return Promise.resolve(cache[index]);
      }
      if (loading[index]) {
        return loading[index];
      }
      var image = new Image();
      image.decoding = 'async';
      image.src = frames[index];
      cache[index] = image;
      loading[index] = new Promise(function (resolve) {
        function finish() {
          if (typeof image.decode === 'function') {
            image
              .decode()
              .catch(function () {})
              .then(function () {
                ready[index] = true;
                resolve(image);
              });
          } else {
            ready[index] = true;
            resolve(image);
          }
        }
        if (image.complete && image.naturalWidth > 0) {
          finish();
          return;
        }
        image.addEventListener('load', finish, { once: true });
        image.addEventListener(
          'error',
          function () {
            resolve(null);
          },
          { once: true }
        );
      });
      return loading[index];
    }
    /*
     * ============================================================
     * TROCA DE FRAME
     * ============================================================
     */
    var paintRaf = 0;

    function primeNeighbors(index) {
      preload(index + 1, true);
      preload(index - 1, true);
      preload(index + 2, true);
      preload(index - 2, true);
    }

    function paint(index) {
      index = normalizeIndex(index, frames.length);
      if (index === wanted && index === current && !paintRaf) return;

      wanted = index;
      updateRange(index);
      if (paintRaf) return;

      paintRaf = window.requestAnimationFrame(function () {
        paintRaf = 0;
        var target = wanted;
        if (target === current) return;
        var token = ++paintToken;

        function commit() {
          if (token !== paintToken || wanted !== target || !ready[target]) return;
          frame.src = frames[target];
          current = target;
          primeNeighbors(target);
        }

        if (ready[target] && cache[target]) {
          commit();
        } else {
          preload(target, true).then(function (image) {
            if (image) commit();
          });
        }
      });
    }

    /*
     * ============================================================
     * PRELOAD COMPLETO EM SEGUNDO PLANO
     * ============================================================
     */
    var warmStarted = false;
    var warmBoosted = false;
    var warmQueue = [];
    var warmCursor = 0;

    function warmWorker() {
      if (warmCursor >= warmQueue.length) return;
      var index = warmQueue[warmCursor++];
      preload(index).then(warmWorker);
    }

    // By default user interaction boosts throughput. Background mode = true.
    function warmAll(background) {
      var interactive = background !== true;
      if (!warmStarted) {
        warmStarted = true;
        for (var distance = 1; distance < frames.length; distance++) {
          var right = normalizeIndex(distance, frames.length);
          var left = normalizeIndex(-distance, frames.length);
          if (warmQueue.indexOf(right) === -1) warmQueue.push(right);
          if (warmQueue.indexOf(left) === -1) warmQueue.push(left);
        }
        warmBoosted = interactive;
        var workers = (saveData || slowConnection) ? 1 : (interactive ? 4 : 2);
        for (var i = 0; i < workers; i++) warmWorker();
      } else if (interactive && !warmBoosted) {
        warmBoosted = true;
        var additional = (saveData || slowConnection) ? 1 : 2;
        for (var j = 0; j < additional; j++) warmWorker();
      }
    }

    /*
     * ============================================================
     * ARRASTE ESTÁVEL
     * ============================================================
     *
     * Não calcula o frame pela posição absoluta do dedo.
     * Acumula somente o movimento real.
     *
     * Isso evita ficar alternando:
     * 10 -> 11 -> 10 -> 11
     * com pequenas oscilações do dedo/mouse.
     */
    var pointerId = null;
    var lastX = 0;
    var carry = 0;
    function pixelsPerFrame() {
      /*
       * Antes ficava perto de 9–11px em muitos celulares.
       * Isso deixava o PDP perceptivelmente mais pesado que o Best Sellers.
       *
       * Agora fica em torno de 6px/frame:
       * rápido o bastante para parecer contínuo,
       * sem virar uma roleta nervosa.
       */
      return Math.max(
        5.5,
        Math.min(
          6.5,
          stage.clientWidth / 64
        )
      );
    }
    function onPointerDown(event) {
      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }
      pointerId = event.pointerId;
      lastX = event.clientX;
      carry = 0;
      root.classList.add('is-dragging');
      /*
       * Ao primeiro toque, prioriza ângulos próximos.
       * Na PDP existe só um produto 360 por vez, então podemos ser
       * mais agressivos aqui do que no carrossel de Best Sellers.
       */
      primeNeighbors(wanted);
      warmAll();
      try {
        stage.setPointerCapture(pointerId);
      } catch (e) {}
    }
    function onPointerMove(event) {
      if (
        pointerId === null ||
        event.pointerId !== pointerId
      ) {
        return;
      }
      var x = event.clientX;
      var delta = x - lastX;
      lastX = x;
      /*
       * Ignora micromovimento involuntário.
       */
      if (Math.abs(delta) < 0.35) return;
      carry += delta;
      var threshold = Math.min(
        FRAME_STEP,
        pixelsPerFrame()
      );
      if (carry <= -threshold) {
        var forward = Math.floor(-carry / threshold);
        carry += forward * threshold;
        paint(wanted + forward);
      } else if (carry >= threshold) {
        var backward = Math.floor(carry / threshold);
        carry -= backward * threshold;
        paint(wanted - backward);
      }
    }
    function endPointer(event) {
      if (pointerId === null) return;
      if (
        event &&
        event.pointerId !== undefined &&
        event.pointerId !== pointerId
      ) {
        return;
      }
      try {
        stage.releasePointerCapture(pointerId);
      } catch (e) {}
      pointerId = null;
      carry = 0;
      root.classList.remove('is-dragging');
    }
    stage.addEventListener(
      'pointerdown',
      onPointerDown
    );
    stage.addEventListener(
      'pointermove',
      onPointerMove
    );
    stage.addEventListener(
      'pointerup',
      endPointer
    );
    stage.addEventListener(
      'pointercancel',
      endPointer
    );
    /*
     * ============================================================
     * BARRA / SCRUBBER
     * ============================================================
     */
    if (range) {
      range.max = String(frames.length - 1);
      range.addEventListener(
        'pointerdown',
        function () {
          warmAll();
        }
      );
      range.addEventListener(
        'input',
        function () {
          var index =
            parseInt(range.value, 10) || 0;
          wanted = normalizeIndex(
            index,
            frames.length
          );
          /*
           * Atualiza visualmente a posição da bolinha
           * imediatamente, mesmo se o frame ainda estiver
           * terminando de decodificar.
           */
          var max = Math.max(
            1,
            frames.length - 1
          );
          range.style.setProperty(
            '--ds-360-progress',
            ((wanted / max) * 100) + '%'
          );
          paint(wanted);
        }
      );
    }
    /*
     * ============================================================
     * BOTÕES / TECLADO
     * ============================================================
     */
    if (prev) {
      prev.addEventListener(
        'click',
        function () {
          warmAll();
          paint(wanted - 1);
        }
      );
    }
    if (next) {
      next.addEventListener(
        'click',
        function () {
          warmAll();
          paint(wanted + 1);
        }
      );
    }
    stage.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          warmAll();
          paint(wanted - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          warmAll();
          paint(wanted + 1);
        }
      }
    );
    /*
     * ============================================================
     * PRIMEIRO CARREGAMENTO
     * ============================================================
     */
    var primed = false;

    function primeAfterHero() {
      if (primed) return;
      primed = true;

      // Only adjacent angles first. No immediate 10+ image burst at page entry.
      preload(1, true);
      preload(frames.length - 1, true);
      window.setTimeout(function () {
        preload(2, true);
        preload(frames.length - 2, true);
      }, 140);

      // Other angles: 2 low-priority requests at a time, after initial paint.
      if (!saveData && !slowConnection) {
        window.setTimeout(function () {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(function () { warmAll(true); }, { timeout: 1400 });
          } else {
            warmAll(true);
          }
        }, 650);
      }
    }

    if (ready[0]) {
      primeAfterHero();
    } else {
      frame.addEventListener('load', primeAfterHero, { once: true });
    }

  }
  function init(scope) {
    var context =
      scope && scope.querySelectorAll
        ? scope
        : document;
    context
      .querySelectorAll(SELECTOR)
      .forEach(initViewer);
    if (
      context.matches &&
      context.matches(SELECTOR)
    ) {
      initViewer(context);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(event.target || document);
    }
  );
})();
